export default [
  {
    fullName: 'Дмитрий Трифонов',
    jobTitle: 'Разработчик интерфейсов,<br>Яндекс.Еда',
    photo: require('@/assets/speakers/Дмитрий.jpg')
  },
  {
    fullName: 'Герман Никитин',
    jobTitle: 'Ведущий разработчик клиентских приложений,<br>Центр Орбита',
    photo: require('@/assets/speakers/Никитин.jpg')
  },
  {
    fullName: 'Никита Любицкий',
    jobTitle: 'Team Lead Mobile Web,<br>Звук',
    photo: require('@/assets/speakers/Любицкий.jpeg')
  },
  {
    fullName: 'Павел Василюк',
    jobTitle: 'Руководитель группы разработки,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Vasiluk.jpg')
  },
  {
    fullName: 'Паша Коршиков',
    jobTitle: 'Ведущий и лидер сообщества разработчиков,<br>Холдинг Т1',
    photo: require('@/assets/speakers/Коршиков.jpg')
  }
]
